import { Node } from '@tiptap/react';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ReviewBlockView } from './ReviewBlockView';

export const ReviewBlock = Node.create({
    name: 'reviewBlock',

    group: 'block',

    defining: true,

    isolating: true,

    addAttributes() {
        return {};
    },

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            { 'data-type': this.name, class: 'review-node-wrapper' },
            [
                'div',
                { class: 'review-content' },
                [
                    'div',
                    { class: 'review-grid' },
                    'Customer Reviews'
                ]
            ]
        ];
    },

    addCommands() {
        return {
            setReviewBlock:
                () =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: {},
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(ReviewBlockView);
    },
});